import { BoxProps } from '@apia/theme';
import { TDomProps } from '../../../../store/selection/types';
import { TTreeProps, TDataNode, TId } from './types';
import TreeDataController from './TreeDataController';

export function getActiveDescendantName(treeName: string, nodeId: TId) {
  return `${treeName}__${nodeId}`;
}

export function getDomProps(
  treeProps: TTreeProps,
  treeName: string,
  type: 'tree',
  node: TTreeProps,
  controller: TreeDataController,
): BoxProps;
export function getDomProps(
  treeProps: TTreeProps,
  treeName: string,
  type: 'node',
  node: TDataNode,
): BoxProps;
export function getDomProps(
  _: TTreeProps,
  treeName: string,
  type: 'tree' | 'node',
  par: TDataNode | TTreeProps,
): TDomProps {
  switch (type) {
    case 'node': {
      const node = par as TDataNode;
      return {
        'aria-expanded': node.isLeaf ? undefined : !!node.isExpanded,
        'data-key': node.id,
        id: getActiveDescendantName(treeName, node.id),
        role: 'treeitem',
        'aria-disabled': node.isDisabled,
        'aria-selected': !node.isDisabled ? !!node.isSelected : undefined,
      };
    }
    default: {
      const tree = par as TTreeProps;
      return {
        role: 'tree',
        'aria-multiselectable': tree.isMultiple,
      };
    }
  }
}
